import { ShoppingBagIcon } from '@heroicons/react/outline';
import { createBaseColumn } from '../../utils/columnUtils';
import { TableTemplate } from '../../types';

export const shopifyIntegrationTemplate: TableTemplate = {
  id: 'shopify_integration',
  name: 'Shopify Integration',
  description: 'Generate unique Shopify discount codes for creator campaigns',
  icon: ShoppingBagIcon,
  iconName: 'ShoppingBagIcon',
  variant: 'gradient',
  defaultConfig: {
    columns: [
      createBaseColumn('discount_code', 'Discount Code', {
        cell_type: 'shopify',
        prompt: 'Generate a unique discount code for this creator using the configured template. The code should be personalized and trackable.',
        data_type: 'text',
        platform_resources: [{ platform: 'shopify', type: 'ecommerce' }],
        shopify_config: {
          subtype: 'discount_code',
          code_name_template: 'CREATOR{handle}',
          allow_custom_name: true,
          price_rule_id: '',
          price_rule_name: ''
        }
      })
    ]
  }
};
